import { updateDoc, increment } from "firebase/firestore";

export const updateViewCount = (documentRef) => updateDoc(documentRef, { views: increment(1) });
